import { fetchData } from '@services/api-service';

export const getAllLifeScriptsAndMemories = async () => {
  return fetchData({ requestUrl: 'getAllLifeAndMemories' });
};
export const getUser = async () => {
  return fetchData({ requestUrl: 'fetchUser' });
};
